import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ZapIcon } from 'lucide-react';
export function Pricing() {
  const features = ['All qualification frameworks', 'Unlimited call processing', 'Full HubSpot sync', 'Slack review workflows', 'Priority support from the founding team'];
  return <section id="pricing" className="py-28 md:py-36 bg-white border-t border-slate-100" data-id="element-301">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12" data-id="element-302">
        <div className="text-center mb-12" data-id="element-303">
          <div className="text-xs uppercase tracking-[0.2em] font-medium text-teal-600 mb-4" data-id="element-304">
            Pricing
          </div>
          <h2 className="text-4xl md:text-5xl font-medium text-slate-900 mb-6" data-id="element-305">
            Free during early access
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="max-w-lg mx-auto bg-white border border-slate-200 rounded-2xl p-10 shadow-sm text-center" data-id="element-306">
          <div className="flex items-baseline justify-center mb-4" data-id="element-307">
            <span className="text-5xl font-medium text-slate-900" data-id="element-308">$0</span>
            <span className="text-lg text-slate-500 ml-2" data-id="element-309">
              /month during beta
            </span>
          </div>

          <p className="text-slate-600 text-base mt-4 mb-8" data-id="element-310">
            All features included. No credit card required. We are building
            Kinase with our first customers and want your feedback.
          </p>

          <ul className="space-y-3 mb-8 text-left" data-id="element-311">
            {features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-312">
                <CheckIcon className="w-5 h-5 text-teal-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-313" />
                <span className="text-slate-600 text-sm" data-id="element-314">{feature}</span>
              </li>)}
          </ul>

          <a href="https://app.getkinase.com" className="w-full py-3 bg-teal-500 hover:bg-teal-400 text-white rounded-lg font-medium transition-colors flex items-center justify-center space-x-2 shadow-sm shadow-teal-500/20" data-id="element-315">
            <ZapIcon className="w-4 h-4" data-id="element-316" />
            <span data-id="element-317">Request free early access</span>
          </a>
        </motion.div>

        <p className="text-sm text-slate-400 mt-6 text-center" data-id="element-318">
          Paid plans will be introduced after beta. Early access customers will
          be grandfathered.
        </p>
      </div>
    </section>;
}